import React from 'react';

import { Description as DescriptionIcon, Assignment as AssignmentIcon } from '@mui/icons-material';
import { Box, ToggleButton, ToggleButtonGroup } from '@mui/material';

export type LetterType = 'engagement' | 'waiver';

interface LetterTypeToggleProps {
  value: LetterType;
  onChange: (value: LetterType) => void;
}

const LetterTypeToggle = ({ value, onChange }: LetterTypeToggleProps) => {
  const handleChange = (_event: React.MouseEvent<HTMLElement>, newValue: LetterType | null) => {
    if (newValue) {
      onChange(newValue);
    }
  };

  return (
    <Box sx={{ mb: 3 }}>
      <ToggleButtonGroup value={value} exclusive onChange={handleChange} color="primary">
        <ToggleButton value="engagement">
          <DescriptionIcon sx={{ mr: 1 }} />
          Engagement Letters
        </ToggleButton>
        <ToggleButton value="waiver">
          <AssignmentIcon sx={{ mr: 1 }} />
          Waiver Letters
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};

export default LetterTypeToggle;
